const ChevronLeftIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M34.524 239.029L228.485 45.071c9.373-9.373 24.569-9.373 33.941 0l22.627 22.627c9.373 9.373 9.373 24.569 0 33.941L124.485 256l160.568 160.361c9.373 9.373 9.373 24.569 0 33.941l-22.627 22.627c-9.373 9.373-24.569 9.373-33.941 0L34.524 272.971c-9.373-9.373-9.373-24.569 0-33.942z" />
  </svg>
);

export default ChevronLeftIcon;
